import React from "react";
import { Select } from '@mantine/core';

import InputWrapperCustom from "../general/InputWrapperCustom";

const BarangCategoryDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={stateData.data.label}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription=''
            >
                <Select
                    readOnly
                    value={stateData.data.value.id}
                    data={[
                        { value: '', label: 'Pilih Kategori Barang' },
                        ...stateData.dataBarangCategory.map(key => ({ value: key.barang_category_id, label: key.barang_category_name }))
                    ]}

                    styles={(tema) => ({
                        input: {
                            backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                        },
                        wrapper: {
                            marginTop: '.75rem'
                        }
                    })}
                />
            </InputWrapperCustom>
        </React.Fragment>
    )
}

export default BarangCategoryDibatalkan;